// extracted by mini-css-extract-plugin
export default {"root":"TruncatedText_root__AO5Oo","clamp":"TruncatedText_clamp__cAZ3+","link":"TruncatedText_link__K92H1","readMore":"TruncatedText_readMore__edsoi"};